const texts = {
    "variant.Color": {
        EN: "Color",
        DA: "Farve",
        DE: "Farbe",
        NL: "Kleur",
        FR: "Couleur",
        IT: "Colore",
        ES: "Color",
        PT: "Cor",
        FI: "Väri",
        SV: "Färg",
        NO: "Farge",
    },
    "variant.Size": {
        EN: "Size",
        DA: "Størrelse",
        DE: "Größe",
        NL: "Maat",
        FR: "Taille",
        IT: "Taglia",
        ES: "Talla",
        PT: "Tamanho",
        FI: "Koko",
        SV: "Storlek",
        NO: "Størrelse",
    },
    "variant.Grip": {
        EN: "Grip",
        DA: "Greb",
        DE: "Griff",
        NL: "Grip",
        FR: "Grip",
        IT: "Presa",
        ES: "Agarre",
        PT: "Aderência",
        FI: "Ote",
        SV: "Grepp",
        NO: "Grep",
    },
    "variant.UNKNOWN": {
        EN: "Type",
        DA: "Type",
        DE: "Typ",
        NL: "Type",
        FR: "Type",
        IT: "Tipo",
        ES: "Tipo",
        PT: "Tipo",
        FI: "Tyyppi",
        SV: "Typ",
        NO: "Type",
    },
    "packing-instructions.title": {
        EN: "Where do you live?",
        DA: "Hvor bor du?",
        DE: "Wo wohnst du?",
        NL: "Waar woon je?",
        FR: "Où habitez-vous?",
        IT: "Dove abiti?",
        ES: "¿Dónde vives?",
        PT: "Onde você mora?",
        FI: "Missä asut?",
        SV: "Var bor du?",
        NO: "Hvor bor du?",
    },
    "packing-instructions.button-apartment": {
        EN: "Apartment",
        DA: "Lejlighed",
        DE: "Wohnung",
        NL: "Appartement",
        FR: "Appartement",
        IT: "Appartamento",
        ES: "Apartamento",
        PT: "Apartamento",
        FI: "Kerrostalo",
        SV: "Lägenhet",
        NO: "Leilighet",
    },
    "packing-instructions.button-house": {
        EN: "House",
        DA: "Hus",
        DE: "Haus",
        NL: "Huis",
        FR: "Maison",
        IT: "Casa",
        ES: "Casa",
        PT: "Casa",
        FI: "Omakotitalo",
        SV: "Villa",
        NO: "Enebolig",
    },
    "packing-instructions.button-townhouse": {
        EN: "Townhouse",
        DA: "Rækkehus",
        DE: "Reihenhaus",
        NL: "Rijtjeshuis",
        FR: "Maison mitoyenne",
        IT: "Casa a schiera",
        ES: "Casa adosada",
        PT: "Casa geminada",
        FI: "Rivitalo",
        SV: "Radhus",
        NO: "Rekkehus",
    },
    "packing-instructions.pack-this-item": {
        EN: "Place this item in the package with the code: ",
        DA: "Læg denne vare i pakken med koden: ",
        DE: "Legen Sie diesen Artikel in das Paket mit dem Code: ",
        NL: "Plaats dit item in het pakket met de code: ",
        FR: "Placez cet article dans le colis avec le code: ",
        IT: "Posiziona questo articolo nel pacco con il codice: ",
        ES: "Coloca este artículo en el paquete con el código: ",
        PT: "Coloque este item na embalagem com o código: ",
        FI: "Laita tämä tuote pakettiin, jossa on koodi: ",
        SV: "Lägg den här varan i paketet med koden: ",
        NO: "Legg denne varen i pakken med koden: ",
    },
    "packing-instructions.button-go-to-order": {
        EN: "Order status",
        DA: "Ordrestatus",
        DE: "Bestellstatus",
        NL: "Bestellingsstatus",
        FR: "Statut de la commande",
        IT: "Stato dell'ordine",
        ES: "Estado del pedido",
        PT: "Status do pedido",
        FI: "Tilauksen tila",
        SV: "Gå till orderstatus",
        NO: "Gå til ordrestatus",
    },
    "packing-instructions.pack-these-items": {
        EN: "Place p{this item|these items} in the original package:",
        DA: "Læg p{denne vare|disse varer} i den originale emballage:",
        DE: "Legen Sie p{diesen Artikel|diese Artikel} in die Originalverpackung:",
        NL: "Plaats p{dit item|deze items} in de originele verpakking:",
        FR: "Placez p{cet article|ces articles} dans l'emballage d'origine:",
        IT: "Posiziona p{questo articolo|questi articoli} nella confezione originale:",
        ES: "Coloca p{este artículo|estos artículos} en el paquete original:",
        PT: "Coloque p{este item|estes itens} na embalagem original:",
        FI: "Laita p{tämä tuote|nämä tuotteet} alkuperäiseen pakkaukseen:",
        SV: "Packa p{varan|varorna} nedan i originalförpackningen:",
        NO: "Pakk p{varen|varene} nedenfor i originalemballasjen:",
    },
    "packing-instructions.write-code": {
        EN: "On the original package, write this code:",
        DA: "Skriv denne kode på originalemballagen:",
        DE: "Schreiben Sie diesen Code auf die Originalverpackung:",
        NL: "Schrijf deze code op de originele verpakking:",
        FR: "Écrivez ce code sur l'emballage d'origine:",
        IT: "Scrivi questo codice sulla confezione originale:",
        ES: "Escribe este código en el paquete original:",
        PT: "Escreva este código na embalagem original:",
        FI: "Kirjoita alkuperäiseen pakkaukseen tämä koodi:",
        SV: "På originalförpackningen skriver du följande kod:",
        NO: "Skriv følgende kode på originalemballasjen:",
    },
    "packing-instructions.write-code-tip": {
        EN: "Tip, you can write the code on a white piece of paper that you tape onto the package.",
        DA: "Tip: Du kan skrive koden på et hvidt stykke papir, som du sætter fast på pakken med tape.",
        DE: "Tipp: Sie können den Code auf ein weißes Papier schreiben und es auf das Paket kleben.",
        NL: "Tip: je kunt de code op een wit stuk papier schrijven dat je op het pakket plakt.",
        FR: "Astuce : vous pouvez écrire le code sur un morceau de papier blanc que vous collez sur le colis.",
        IT: "Suggerimento: puoi scrivere il codice su un pezzo di carta bianca che attacchi al pacco.",
        ES: "Consejo: puedes escribir el código en un papel blanco que pegues en el paquete.",
        PT: "Dica: você pode escrever o código em um pedaço de papel branco que você cola na embalagem.",
        FI: "Vinkki: voit kirjoittaa koodin valkoiselle paperille, jonka teippaat pakkaukseen.",
        SV: "Tips: skriv koden tydligt på ett papper och tejpa fast det på paketet.",
        NO: "Tips: Skriv koden tydelig med mørk penn på hvitt papir og teip det på pakken.",
    },
    "packing-instructions.summary-night-info": {
        EN: "The courier picks up the p{package|packages} after midnight",
        DA: "Buddet henter p{pakken|pakkerne} efter midnat",
        DE: "Der Kurier holt p{das Paket|die Pakete} nach Mitternacht ab",
        NL: "De koerier haalt p{het pakket|de pakketten} na middernacht op",
        FR: "Le coursier récupère p{le colis|les colis} après minuit",
        IT: "Il corriere ritira p{il pacco|i pacchi} dopo mezzanotte",
        ES: "El mensajero recoge p{el paquete|los paquetes} después de la medianoche",
        PT: "O entregador coleta p{o pacote|os pacotes} após a meia-noite",
        FI: "Kuriiri noutaa p{paketin|paketit} keskiyön jälkeen",
        SV: "Budet hämtar p{paketet|paketen} efter midnatt",
        NO: "Budet henter p{pakken|pakkene} etter midnatt.",
    },
    "packing-instructions.summary-house-intro": {
        EN: "Place the p{package|packages} inside or beside your mailbox on",
        DA: "Læg p{pakken|pakkerne} i eller ved siden af din postkasse den",
        DE: "Legen Sie p{das Paket|die Pakete} in oder neben Ihren Briefkasten am",
        NL: "Plaats p{het pakket|de pakketten} in of naast je brievenbus op",
        FR: "Placez p{le colis|les colis} dans ou à côté de votre boîte aux lettres le",
        IT: "Posiziona p{il pacco|i pacchi} dentro o accanto alla tua cassetta postale il",
        ES: "Coloca p{el paquete|los paquetes} dentro o al lado de tu buzón el",
        PT: "Coloque p{o pacote|os pacotes} dentro ou ao lado da sua caixa de correio no dia",
        FI: "Aseta p{paketti|paketit} postilaatikon sisään tai viereen",
        SV: "Lägg p{paketet|paketen} i eller intill din brevlåda på",
        NO: "Legg p{pakken|pakkene} i eller ved siden av postkassen din",
    },
    "packing-instructions.summary-house-outro": {
        EN: "If you place the p{package|packages} in your mailbox, make sure that's unlocked so the courier can open it",
        DA: "Hvis du lægger p{pakken|pakkerne} i postkassen, skal du sørge for at den er ulåst, så buddet kan åbne den",
        DE: "Wenn Sie p{das Paket|die Pakete} in Ihren Briefkasten legen, stellen Sie sicher, dass er nicht verschlossen ist, damit der Kurier ihn öffnen kann",
        NL: "Als je p{het pakket|de pakketten} in je brievenbus legt, zorg dan dat deze niet op slot zit zodat de koerier hem kan openen",
        FR: "Si vous placez p{le colis|les colis} dans votre boîte aux lettres, assurez-vous qu'elle est déverrouillée pour que le coursier puisse l'ouvrir",
        IT: "Se posizioni p{il pacco|i pacchi} nella tua cassetta postale, assicurati che sia sbloccata in modo che il corriere possa aprirla",
        ES: "Si colocas p{el paquete|los paquetes} en tu buzón, asegúrate de que esté desbloqueado para que el mensajero pueda abrirlo",
        PT: "Se você colocar p{o pacote|os pacotes} em sua caixa de correio, certifique-se de que esteja desbloqueada para que o entregador possa abri-la",
        FI: "Jos asetat p{paketin|paketit} postilaatikkoon, varmista että se on auki, jotta kuriiri voi avata sen",
        SV: "Om du lägger p{paketet|paketen} i postlådan, se till att den är olåst så att budet kan öppna den",
        NO: "Hvis du legger p{pakken|pakkene} i postkassen, sørg for at den er ulåst slik at budet får tilgang",
    },
    "packing-instructions.summary-apartment-intro": {
        EN: "Place the p{package|packages} outside your apartment door",
        DA: "Læg p{pakken|pakkerne} uden for din lejlighedsdør",
        DE: "Legen Sie p{das Paket|die Pakete} vor Ihre Wohnungstür",
        NL: "Plaats p{het pakket|de pakketten} buiten je appartementsdeur",
        FR: "Placez p{le colis|les colis} devant votre porte d'appartement",
        IT: "Posiziona p{il pacco|i pacchi} fuori dalla porta del tuo appartamento",
        ES: "Coloca p{el paquete|los paquetes} fuera de la puerta de tu apartamento",
        PT: "Coloque p{o pacote|os pacotes} do lado de fora da porta do seu apartamento",
        FI: "Aseta p{paketti|paketit} asuntosi oven ulkopuolelle",
        SV: "Lägg p{paketet|paketen} utanför din lägenhetsdörr på",
        NO: "Sett p{pakken|pakkene} utenfor leilighetsdøren din",
    },
};
export default texts;
